import { Component } from '@angular/core';

@Component({
    selector: 'indication',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class IndicationComponent {}
